<template>
  <!-- <div> -->

    <!-- <div class="video-container">
      <img :src="imgSrc" alt="">
      <img class="icon-play" :class="{ 'icon-play-mob': !isPc }" :src="playBtnImg" alt="" @click="handelPlayVideo">
    </div>
    <div class="cover"  v-if="isShowCover">
      <i class="el-icon-close" :class="{'el-icon-close-mob': !isPc}" @click="hideCover" :code-stm="`event, PAGEURL页面, ev5 tvc 关闭弹窗`"></i>
      <div class="pop-video" :class="{ 'pop-video-mob': !isPc }" v-if="isShowVideo" >
        <video class="my-video" :src="videoSrc" autoplay="true" loop="false" muted="false" direction="0" controls></video>
      </div>
    </div> -->
    <video style="width: 100%;display: block;" :src="videoSrc" loop="false" playsinline :poster="imgSrc" muted="false" direction="0" controls></video>

  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, isSafariFun, isPc } from "@/utils/utils.js";
export default {
  props: ["height"],
  data() {
    return {
      imgList: [],
      isPortrait: isPortraitFun(),
      isSafari: isSafariFun(),
      isPc: isPc(),
      showBtn: false,
      imgSrc: '/assets/~/media/images/vehicle/ev5/adv/videoimg01.png',
      playBtnImg: require('@/assets/images/play.png'),
      videoSrc: 'https://img.kia.cn/content/video/20240313/01.mp4',
      isShowCover:false,
      isShowVideo: false,
    };
  },
  computed: {
    host() {
      let host = process.env.VUE_APP_API_ENV == 'production' ? "https://www.kia.cn" : "https://uat.kia.cn"
      return host
    }
  },
  methods: {
    handelPlayVideo() {
      this.videoSrc = "https://img.kia.cn/content/video/20240313/01.mp4"
      this.isShowCover = true
      this.isShowVideo = true
    },
    hideCover(){
      // this.hideVideo()
      this.videoSrc = ""
      this.isShowVideo = false
      
      this.isShowCover = false
      this.$forceUpdate()
    },
    hideVideo(){
      console.log("关闭");
      
    }
  },
  watch: {
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.video-container {
  width: 100vw;
  position: relative;

  img {
    width: 100%;
    height: auto;
    /* max-width: 100%;transform:translate3d(0,0,0) */
    /* height: 100%;
      object-fit: cover; */
  }

  .icon-play {
    width: 10% !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    &-mob {
      // top: calc(50% - 10px);
    }
  }


  /* transform */
}
.cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 10;
    .el-icon-close {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: 50px;
      top: 50px;
      &-mob {
        font-size: 30px;
        right: 20px;
      }
    }
    .pop {
      position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .pop-video {
      width: 60%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &-mob {
        width: 100%;
      }
      video {
        width: 100%;
      }
    }
    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;
      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
      /* height: 80%; */
      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);
        img {
          width: 78%;
          height: auto;
        }
        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }
        .icon-play {
          width: 5%!important;
        }
        @media (max-width: 768px) {
          .icon-play {
            width: 10%!important;
          }
        }
      }
      &-mob {
        width: 100vw;
      }
    }
    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -30px;
      color: #fff;
    }
    .swiper-button-next, .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);
      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }
      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }
      &:hover::after {
        color: #fff;
      }
    }
    .swiper-button-prev, .swiper-button-next:focus {
      outline: none;
    }
    .swiper-button-next2 {
        right: 0;
        transform: translateY(-25%);
    }
    .swiper-button-prev2 {
        left: 0;
        transform: translateY(-25%);
    }
    @media (max-width: 768px) {
      .swiper-button-next2 {
          width: auto;
          height: auto;
          right: 2%;
          transform: translateY(25%);
      }
      .swiper-button-prev2 {
          width: auto;
          height: auto;
          left: 2%;
          transform: translateY(25%);
      }
    }
  }
</style>
